import { render, staticRenderFns } from "./ModelInformation.vue?vue&type=template&id=ce97f412&scoped=true"
import script from "./ModelInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModelInformation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ModelInformation.vue?vue&type=style&index=0&id=ce97f412&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce97f412",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce97f412')) {
      api.createRecord('ce97f412', component.options)
    } else {
      api.reload('ce97f412', component.options)
    }
    module.hot.accept("./ModelInformation.vue?vue&type=template&id=ce97f412&scoped=true", function () {
      api.rerender('ce97f412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/ModelInformation.vue"
export default component.exports